import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { ActivityIndicator, View } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { event_bulkGetAthletes, event_bulkGetTeams } from '../../../store/actionsv1/events';
import { market_getLatestTradesByEventId, market_setDraftOrder } from '../../../store/actionsv1/markets';
import { EventOrderStatProps, MarketProps, TradeProps } from '../../../store/types/mk_svc';
import { AthleteProps, MatchProps, TeamProps } from '../../../store/types/sr_svc';
import { useIsInViewport } from '../../../utilsv1/helpers';
import { market_getMarketsFromSupportedMarkets } from '../helpers/markets';
import { trade_getOrderFromTrade } from '../helpers/trades';
import MarketCard from './MarketCard';
import { Image } from 'react-native';
import { navigate } from '../../../navigation/RootNavigation';

type MatchMarketCardProps = {
    match_id: string,
    source?:'market'|'competition_play',
    market_override?:MarketProps,
    trades_override?:TradeProps[],
    hide_market_footers?:boolean
}

const MatchMarketCard = ({ match_id, source, market_override, trades_override, hide_market_footers }:MatchMarketCardProps) => {
    const [ loaded, setLoaded ] = useState(false)
    const dispatch = useDispatch();
    const match:MatchProps | undefined = useSelector((state:any) => state.event.matches[match_id], (left, right) => left.match_id == right.match_id)
    let match_participants:string[] = []
    if(match){ match_participants = match.participants }
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left.length === right.length)
    const athletes:AthleteProps[] = useSelector((state:any) => state.event.athletes_list.athletes.filter(a => match_participants.includes(a.athlete_id)), (left, right) => left.length === right.length)
    const teams:TeamProps[] = useSelector((state:any) => state.event.teams_list.teams.filter(t => match_participants.includes(t.team_id)), (left, right) => left.length === right.length)
    let order_stats = useSelector((state:any) => state.market.order_stats[`match:${match_id}`] ?? [], (left, right) => left == right);
    let order_stat = order_stats.find(os => os.market_id == market_override?.market_id);
    const available_markets = market_getMarketsFromSupportedMarkets(match?.supported_markets??[], markets)
    const match_ref = useRef()
    const isInViewport1 = useIsInViewport(match_ref)
    
    useEffect(() => {
        if(!loaded && isInViewport1){
            getDataFromServer(match?.participants)
        }
    },[isInViewport1])

    const getDataFromServer = async(participant_ids:string[]) => {
        await dispatch(market_getLatestTradesByEventId(match_id, 'match'))
        if(match?.participant_type == 'team'){ dispatch(event_bulkGetTeams(participant_ids)) } //Only support athletes right now
        if(match?.participant_type == 'athlete' && athletes.length == 0) { dispatch(event_bulkGetAthletes(participant_ids)) } //Only support athletes right now
        setLoaded(true)
    }
    let away_team = undefined, home_team = undefined, away_athlete = undefined, home_athlete = undefined
    if(match?.participant_type == 'athlete'){
        away_athlete = athletes.find(a => a.athlete_id == match?.participants[0])
        home_athlete = athletes.find(a => a.athlete_id == match?.participants[1])
    }
    if(match?.participant_type == 'team'){
        away_team = teams.find(a => a.team_id == match?.participants[0])
        home_team = teams.find(a => a.team_id == match?.participants[1])
    }


    let open_order_count = order_stat?.open_order_count ?? 0
    let open_order_amount = order_stat?.open_order_amount ?? 0

    return (
        <View ref={match_ref}>
            {!loaded || !match ?
            <View style={{ height:150 }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight}/>
            </View>
            :
            <View style={styles.cardStyle}>
                {match?.match_title ?
                <View style={{ padding:5, backgroundColor:Colors.shades.shade100, borderTopRightRadius:12, borderTopLeftRadius:12 }}>
                    <Text weight='semibold' size={12} color={Colors.brand.midnight}>{match.match_title}</Text>
                </View>
                :<></>}
                <Text style={{ padding:5 }} size={12} color={Colors.shades.black} weight='semibold'>{match?.match_id}: {moment(match?.scheduled_datetime).format('MM/DD @ hh:mm a')}</Text>
                <View style={{flexDirection:'row', padding:7}}>
                    <View style={{ flex:1 }}>
                        {match?.participant_type == 'athlete' ?
                        <View nativeID='athlete_match_info' style={{flex:1}}>
                            <View nativeID="match_away_info" style={{ flex:1, flexDirection:'row', marginRight:3, minHeight:35, alignItems:'center' }}>
                                <Text size={12} color={Colors.shades.black} weight='semibold'>{away_athlete?.first_name} {away_athlete?.last_name}</Text>
                                {match?.winner == away_athlete?.athlete_id ?
                                <Text style={{ marginLeft:5 }} size={12} color={Colors.shades.black} weight='bold'>- Winner</Text>
                                :<></>}
                            </View>
                            <View nativeID="match_home_info" style={{ flex:1, flexDirection:'row', marginRight:3, minHeight:35, alignItems:'center'  }}>
                                <Text size={12} color={Colors.shades.black} weight='semibold'>{home_athlete?.first_name} {home_athlete?.last_name}</Text>
                                {match?.winner == home_athlete?.athlete_id ?
                                <Text style={{ marginLeft:5 }} size={12} color={Colors.shades.black} weight='bold'>- Winner</Text>
                                :<></>}
                            </View>
                        </View>
                        :match?.participant_type == 'team' ? 
                        <View nativeID='team_match_info' style={{ flex:1 }}>
                            <View nativeID="match_away_info" style={{ flex:1, flexDirection:'row', padding:10, marginRight:3, minHeight:35, alignItems:'center' }}>
                                {away_team?.image?.url ?
                                <Image
                                    source={{ uri: away_team.image.url }}
                                    style={{ height:18, width:18, marginRight:5 }}
                                    resizeMode='cover'
                                />
                                :<></>}
                                <Text size={12} color={Colors.shades.black} weight='semibold'>{away_team?.market_name} {away_team?.name}</Text>
                                {match?.winner == away_team?.team_id ?
                                <Text style={{ marginLeft:5 }} size={12} color={Colors.shades.black} weight='bold'>- Winner</Text>
                                :<></>}
                            </View>
                            <View nativeID="match_home_info" style={{ flex:1, flexDirection:'row', padding:10, marginRight:3, minHeight:35, alignItems:'center'  }}>
                                {home_team?.image?.url ?
                                <Image
                                    source={{ uri: home_team.image.url }}
                                    style={{ height:18, width:18, marginRight:5 }}
                                    resizeMode='cover'
                                />
                                :<></>}
                                <Text size={12} color={Colors.shades.black} weight='semibold'>{home_team?.market_name} {home_team?.name}</Text>
                                {match?.winner == home_team?.team_id ?
                                <Text style={{ marginLeft:5 }} size={12} color={Colors.shades.black} weight='bold'>- Winner</Text>
                                :<></>}
                            </View>
                        </View>
                        :<></>}
                    </View>
                    {match.status === 'not_started' ? 
                    <View style={{ flex:1 }}>
                        {available_markets.map(m => {
                            if(market_override && market_override.market_id != m.market_id){ return }
                            let side_array:any = []
                            m.side_options.map((o,i) => {
                                let side:any = { side: o.side }
                                side.side_id = match.participants[i]
                                side_array.push(side)
                            })
                            return (
                                <View style={{flex:1}}>
                                    <MarketCard 
                                        align='vertical' 
                                        market={m} 
                                        source={source}
                                        side_array={side_array}
                                        event_id={match_id} 
                                        trades_override={trades_override}
                                        event_type='match'
                                        onPress={(trade) => dispatch(market_setDraftOrder(trade_getOrderFromTrade(trade)))}
                                        />
                                </View>
                            )
                        })}
                    </View>
                    :
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        <Icon name='lock' type='feather' color={Colors.brand.midnight} size={28}/>
                    </View>
                    }
                </View>
                {!hide_market_footers && market_override && match && match.status == 'not_started' ?
                <View style={{ flexDirection:'row', backgroundColor:Colors.shades.shade100, borderBottomRightRadius:12, borderBottomLeftRadius:12}}>
                    <TouchableOpacity style={{ flex:1, padding:3, paddingLeft:10, flexDirection:'row', alignItems:'center' }} onPress={() => {
                        navigate('Market', { event_id:match.match_id, event_type: 'match', market_id: market_override?.market_id })
                    }}>
                        <View style={{ padding:7, borderRadius:100, backgroundColor:Colors.shades.shade600 }}>
                            <Icon name='bar-chart' type='feather' color={Colors.brand.electric} size={16} />
                        </View>
                        <View style={{ flex:1, padding:7 }}>
                            <Text size={12} color={Colors.brand.midnight}>Liquidity</Text>
                            <Text size={12} color={Colors.brand.electric} weight='bold'>${open_order_amount.toFixed()} • {open_order_count} Open Orders</Text>
                        </View> 
                    </TouchableOpacity>          
                </View>
                :<></>}
            </View>
            }
        </View>
        
    )
}


const styles = {
    cardStyle: { borderRadius: 12, borderWidth: 1, borderColor: Colors.shades.shade400 }
}


export default MatchMarketCard